import { useContext } from 'react';
import PersonCertificationData from './PersonCertificationData';
import { PersonCertificationStateContext } from './PersonCertificationContextProvider';

const usePersonCertificationData = () => {
  const [personCertificationState, setPersonCertificationState] = useContext(PersonCertificationStateContext);

  const getPersonCertificationsByPersonId = (personId) => {
      PersonCertificationData.getPersonCertificationsByPersonIdData(personId, personCertificationState, setPersonCertificationState);
  };

  const resetPersonCertificationStateArrayData = () => {
    setPersonCertificationState({
      ...personCertificationState,
      isArrayLoading: false,
      isArrayLoaded: false,
      arrayData: [],
      message: ''
    });
  }

  return { personCertificationState, getPersonCertificationsByPersonId, resetPersonCertificationStateArrayData };
};

export default usePersonCertificationData;